if (!customElements.get('knn-newsletter')) {
  customElements.define('knn-newsletter', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('dialog');
      this.trigger = this.closest('.knn-footer').querySelector('[data-newsletter-open]');
      this.trigger?.addEventListener('click', (event) => {
        event.preventDefault();
        this.open();
      }, options);
      this.querySelector('[data-newsletter-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => this.trigger?.focus({ preventScroll: true }), options);
      // Shopify renders validation/success after the native customer form POST.
      if (this.querySelector('[data-newsletter-result]')) this.open();
    }
    open() {
      if (!this.dialog.open) this.dialog.showModal();
      this.querySelector('[data-newsletter-result], input[type="email"]')?.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
